module.exports = __webpack_public_path__ + "img/bind_wechat_banner.285814e8.png";